import {$api, config} from "../index";
import {BlocklistItem, CreateShortLink, ShortLinkDto} from "../../types/types";
import {Page, Pageable} from "../../types/page";


export const createLink = (dto: CreateShortLink) => {
    return $api.post<ShortLinkDto>(`/api/v1/generate`, dto, { headers: config()});
}


export const indexBlackList = (pageable: Pageable) => {
    return $api.post<Page<BlocklistItem>>(`/api/v1/blacklist`, pageable, {headers: config(), params: pageable})
}
